<template>
	<div class="report_compliance">
		<base-card title="" class="p-20">
			<template #action>
				<div class="report_calendar_header">
					<div class="title">服药日历</div>
					<div class="tag_row">
						<div class="tag prmary-tag">已服药</div>
						<div class="tag warry-tag">漏服药</div>
						<div class="tag error-tag">未标记</div>
					</div>
				</div>
			</template>
			<div class="report_calendar_content">
				<van-calendar
					v-if="detail.id"
					readonly
					:show-title="false"
					:poppable="false"
					:show-mark="false"
					:show-confirm="false"
					:min-date="minDate"
					:max-date="maxDate"
					:formatter="formatter"
					first-day-of-week="1"
				>
				</van-calendar>
				<div class="calendar_text"
					>您本月已服药 <span class="text-primary">{{ detail.takeMedicine }}</span> 天，漏服药
					<span style="color:#F7BA1E">{{ detail.notTakeMedicine }}</span> 天，未标记
					<span class="text-danger">{{ detail.unmark }}</span> 天</div
				>
			</div>
			<div class="report_calendar_header mt-32" v-if="medicinalScale.length  > 0">
				<div class="title">服药分析</div>
			</div>
			<div class="report_calendar_remind" v-for="(item,index) in medicinalScale" :key="index">
				{{index + 1}}、{{item.medicineName}}的正常服药天数比例为
				{{parseInt(item.normalScale)}} %，未标记/漏服药天数比例为 {{parseInt(100 - item.normalScale)}} %。
			</div>
		</base-card>

		<remind
			title="温馨提示"
			:list="[
                        '正确地服药是治疗疾病的前提, 而按时按量、规律服药是保障药物治疗效果的关键。',
                        '服药的间隔长短和剂量大小是医生根据您的病情决定的，药物的疗效取决于它在血液中保持一定时间的浓度水平，太低则达不到疗效，太高易发生毒副作用。时断时续地服药，漏服后擅自加服，随意加大剂量或减量、 停药等均可能造成药物血液浓度的大幅波动。',
                        '请遵医嘱规律用药，并实时记录您的用药数据，做到不错吃，不漏吃，提高服药依从性，呵护您的身体健康。'
            ]"
		/>
	</div>
</template>
<script>
import remind from './report-detail-remind.vue'
export default {
    name: 'reportCompliance',
    components: { remind },
    props: {
        detail: {
            type: Object,
            default: () => { }
        }
    },
    data () {
        return {
            show: true,
            // minDate: new Date(2010, 0, 1),
            // maxDate: new Date(2010, 0, 31),
        }
    },
    computed: {
        medicinalScale () {
            const { medicinalScale } = this.detail
            return medicinalScale && JSON.parse(medicinalScale)
        },
        dataList () {
            return this.detail.reminderDate || []
        },
        minDate () {
            return new Date(this.$moment(this.detail.startTime))
        },
        maxDate () {
            return new Date(this.$moment(this.detail.endTime))
        }
    },
    methods: {
        formatter (day) {
            const month = day.date.getMonth() + 1;
            const date = day.date.getDate();
            const year = day.date.getFullYear();
            const time = `${year}-${month > 9 ? month : '0' + month}-${date > 9 ? date : '0' + date}`

            let index = this.dataList.findIndex(v => v.date === time)
            if (index > -1) {
                const { state } = this.dataList[index]
                if (state === 2) {
                    day.className = 'primary_calendar'
                }
                if (state === 3) {
                    day.className = 'warry_calendar'
                }
            }

            return day;
        },
    }
}
</script>
<style lang="less" scoped>
.report_compliance {
	padding-top: 28px;
	.report_calendar_header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-family: PingFangSC-Semibold;
		.title {
			font-size: 34px;
			color: #1f2329;
		}
		.tag_row {
			display: flex;
		}
		.tag {
			font-size: 24px;
			color: #ffffff;
			width: 96px;
			text-align: center;
			height: 44px;
			line-height: 44px;
			border-radius: 7px;
			margin-left: 24px;
		}
		.prmary-tag {
			background-color: @primary;
		}
		.warry-tag {
			background-color: #f7ba1e;
		}
		.error-tag {
			background-color: @danger;
		}
	}
	.report_calendar_content {
		background-color: #fafbfc;
		border-radius: 16px;

		padding-bottom: 32px;
	}
	.calendar_text {
		font-size: 26px;
		color: #1f2329;
		vertical-align: bottom;
		text-align: center;
		span {
			font-size: 36px;
		}
	}
	// .p-20 {
	// 	padding: 20px;
	// }
	.report_calendar_remind {
		font-size: 28px;
		color: #1f2329;
		margin: 28px 0;
	}
}
</style>
<style lang="less">
.report_compliance {
	.van-calendar {
		background-color: transparent;
	}
	.van-calendar__header-subtitle {
		font-size: 34px;
		color: #1f2329;
	}
	.van-calendar__header {
		box-shadow: none;
		.van-calendar__weekdays {
			color: @gray-9;
			font-size: 26px;
		}
	}
	.van-calendar__day {
		z-index: 2;
		color: #ffffff;
		font-size: 28px;
		font-weight: 300;
		height: 110px;
	}
	.van-calendar__day::before {
		content: '';
		width: 55px;
		height: 55px;
		border-radius: 28px;
		background-color: @danger;
		position: absolute;
		z-index: -1;
	}
	.primary_calendar::before {
		content: '';
		width: 55px;
		height: 55px;
		border-radius: 28px;
		background-color: #14c9c9;
		position: absolute;
		z-index: -1;
	}
	.warry_calendar::before {
		content: '';
		width: 55px;
		height: 55px;
		border-radius: 28px;
		background-color: #f7ba1e;
		position: absolute;
		z-index: -1;
	}
	.none_calendar {
		display: none;
	}
	.van-calendar__selected-day {
		background-color: transparent;
	}
	.van-calendar__month-title {
		display: none;
	}
}
.mt-32 {
	margin-top: 32px;
}
</style>